module.exports = __webpack_public_path__ + "media/images/lb/383-0908066bd6450f7140012bb19fa9fe94.svg";